export default __webpack_public_path__ + "static/media/photogallery-02.a03b32de.webp";